(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var esc=function(t){var d=document.createElement('div');d.textContent=t||'';return d.innerHTML};
  var money=function(v){return parseFloat(v).toLocaleString('es-ES',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'})};
  document.querySelectorAll('.header-inline-search').forEach(function(form){
    var input=form.querySelector('input[name="q"]'); if(!input) return;
    var box=document.createElement('div'); box.className='header-inline-search__results'; form.appendChild(box);
    var timer,ctrl,active=-1;
    function close(){box.classList.remove('is-open');active=-1}
    function search(q){
      if(ctrl)ctrl.abort(); ctrl=new AbortController();
      fetch(root+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',{signal:ctrl.signal})
      .then(function(r){return r.json()}).then(function(j){
        var p=j.resources.results.products||[];
        box.innerHTML=p.length ? p.map(function(x){
          var img=x.image?'<img src="'+x.image+'&width=120" alt="" loading="lazy">':'';
          var price=parseFloat(x.price)>0?'<small>'+money(x.price)+'</small>':'';
          return '<a href="'+x.url+'">'+img+'<span>'+esc(x.title)+price+'</span></a>';
        }).join('')+'<a class="his-all" href="'+root+'search?q='+encodeURIComponent(q)+'&options[prefix]=last">Ver todos los resultados</a>'
        : '<div class="his-empty">No hay resultados para “'+esc(q)+'”</div>';
        box.classList.add('is-open'); active=-1;
      }).catch(function(){});
    }
    input.addEventListener('input',function(){
      clearTimeout(timer); var q=input.value.trim();
      if(q.length<2){close();return}
      timer=setTimeout(function(){search(q)},250);
    });
    input.addEventListener('focus',function(){if(box.innerHTML&&input.value.trim().length>1)box.classList.add('is-open')});
    input.addEventListener('keydown',function(e){
      var links=box.querySelectorAll('a');
      if(e.key==='Escape'){close();return}
      if(!box.classList.contains('is-open')||!links.length)return;
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){
        e.preventDefault();
        active=(active+(e.key==='ArrowDown'?1:-1)+links.length)%links.length;
        links.forEach(function(l,i){l.classList.toggle('is-active',i===active)});
      } else if(e.key==='Enter'&&active>-1){e.preventDefault();links[active].click()}
    });
    document.addEventListener('click',function(e){if(!form.contains(e.target))close()});
  });
})();